let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iTamo")).then(() => parcelRequire('6bd5D'));